export default __webpack_public_path__ + "static/media/coverageIcon.87af0ee0.svg";